import { dataUserIntersectionSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserIntersectionSolid = /*#__PURE__*/createIcon(dataUserIntersectionSolid)
export default IconUserIntersectionSolid
